import styled from 'styled-components';

export const TabListContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;
